module.exports = "<sb-page-header></sb-page-header> <div class=sb-application-page ng-transclude=content></div> <sb-page-footer></sb-page-footer> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/application-page/application-page.html
// module id = 206
// module chunks = 0